module.exports = __webpack_public_path__ + "static/media/face2.329a651b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/face2.png
// module id = 438
// module chunks = 0